module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGde9c0cc5418f0a45f35b76be2cd1ab1a.de9c0cc5.png";